import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import type { ZuubGet2FAMessagesResponse } from '@/@types/zuub/contracts';

import { makeAPIRequestReactQueryWithHeaders } from '../api';
import { endpoints } from '../endpoints';

// Hook to poll 2FA messages for a single payer
// Polls every 5 seconds
export const useZuubRcmMessage = (
  payerId: number | null,
  enabled: boolean = true,
) => {
  const {
    primaryPracticeId: currentPractice,
    primaryOrganizationId: currentOrg,
  } = useSelector(
    (state: {
      login: {
        user: {
          primaryPracticeId?: string;
          primaryOrganizationId?: string;
        };
      };
    }) => state.login.user,
  );

  const query = useQuery({
    queryKey: [endpoints.rcmZuubOnboarding.messages, payerId],
    queryFn: () =>
      makeAPIRequestReactQueryWithHeaders<ZuubGet2FAMessagesResponse>(
        `${endpoints.rcmZuubOnboarding.messages}/${payerId}`,
        undefined,
        {
          Org: currentOrg,
          Practice: currentPractice,
        },
        'GET',
      ),
    enabled: Boolean(
      currentPractice && currentOrg && enabled && payerId !== null,
    ),
    refetchInterval: 5000, // Poll every 5 seconds
    staleTime: 0, // Always consider data stale to enable polling
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
